import { DownOutlined } from "@ant-design/icons";
import { Button, Checkbox, Divider, Input } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import StackedBarChart from "../../Reuseable/StackedBar/StackedBarChart";
import Tabs from "../../Reuseable/Tabs/Tabs";
import ActionHeader from "../../Reuseable/actionHeader/ActionHeader";
import ChartFilterModal from "../../Reuseable/actionHeader/ChartFilter";
import crossIcon from "../../assets/Icons/crossIcon.svg";
import fileDownload from "../../assets/Icons/file-download.svg";
import searchIcon from "../../assets/Icons/input-search-icon.svg";
import { transformChartData } from "../../assets/helpers";
import ExcelDownloader from "../../assets/helpers/excelDownload";
import {
  fetchAnalysisCoverage,
  fetchAnalysisCoverageCode,
  fetchHMLCategorization,
} from "../../store/analysisSlice";
import {
  hmlCategorizationData,
  recoveryPendingData,
} from "../AnalysisPage/data";
import "./Coverage.scss";

const CoveragePage = () => {
  const [primaryItems, setPrimaryItems] = useState([]);
  const [secondaryItems, setSecondaryItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectTab, setSelectTab] = useState("All");
  const [actionCodeMode, setActionCodeMode] = useState("_count");
  const [selectedTab, setSelectedTab] = useState("Absolute Value");
  const { analysis_coverage } = useSelector((state) => state?.analysis);

  const [open, setOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("team_member");
  const [selectedTrustMap, setSelectedTrustMap] = useState({
    team_member: [],
    team_leader: [],
  });
  const [refresh, setRefresh] = useState(false);
  const dispatch = useDispatch();


  useEffect(() => {
    setSelectedItem(secondaryItems.length > 0 ? [secondaryItems[0]] : []);
  }, [secondaryItems]);

  const dropdownRender = () => (
    <div
      className="secondary-select-dropdown"
      onMouseEnter={() => setDropdownOpen(true)}
    >
      <div className="heading">
        <h2>Trust</h2>
        <img
          src={crossIcon}
          alt=""
          onClick={() => setDropdownOpen(false)}
          style={{ cursor: "pointer" }}
        />
      </div>
      <div className="metric-search-input">
        <Input
          prefix={<img src={searchIcon} alt="icon" />}
          placeholder="Search"
          allowClear
        />
      </div>
      <div className="metric-title">
        <h2>Metrics</h2>
      </div>
      <div className="select-all-container">
        <Button size="small" type="text" onClick={handleSelectAll} danger>
          Select All
        </Button>
      </div>
      <Divider style={{ margin: "8px 0" }} />
      <div className="checkbox-list">
        {secondaryItems.map((item) => (
          <Checkbox
            key={item}
            checked={selectedItems.includes(item)}
            onChange={() => handleCheckboxChange(item)}
          >
            {item}
          </Checkbox>
        ))}
      </div>
    </div>
  );
  const handleCheckboxChange = (value) => {
    setSelectedItems((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const handleSelectAll = () => {
    setSelectedItems(
      selectedItems.length === secondaryItems.length ? [] : [...secondaryItems]
    );
  };

  useEffect(() => {
    dispatch(fetchAnalysisCoverage());
    dispatch(fetchAnalysisCoverageCode());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchHMLCategorization({ ...selectedTrustMap }));
  }, [dispatch, refresh]);

  const { data, keys, colors } = transformChartData(
    analysis_coverage?.action_code_coverage,
    actionCodeMode
  );

  return (
    <>
      <div className="coverage-container">
        <ActionHeader
          heading="Coverage"
          primaryItems={primaryItems}
          secondaryItems={secondaryItems}
          setPrimaryItems={setPrimaryItems}
          showSecondaryItems={true}
          setSecondaryItems={setSecondaryItems}
          fetchData={fetchAnalysisCoverage}
          fetchData2={fetchAnalysisCoverageCode}
          fetchData3={fetchHMLCategorization}
             setRefresh={setRefresh}
        />

        <div className="recovery_pending_chart_wrapper coverage-chart-wrapper">
          <div className="heading recovery-pending-heading">
            <h2>Recovery vs Pending</h2>
            <div className="chart-items">
              {recoveryPendingData?.keys.map((item, index) => {
                return (
                  <div key={item} className="chart-item">
                    <div
                      className="color-box"
                      style={{
                        backgroundColor: recoveryPendingData?.colors[index],
                      }}
                    ></div>
                    <span>{item}</span>
                  </div>
                );
              })}
              <div className="file-download-wrapper">
                <ExcelDownloader
                  data={analysis_coverage?.recovery_and_pending}
                  fileName="Recovery vs Pending"
                />
              </div>
            </div>
          </div>
          <StackedBarChart
            title="Recovery vs Pending"
            margin={{ left: 30, top: 30, bottom: 2 }}
            data={
              Array.isArray(analysis_coverage?.recovery_and_pending) &&
              analysis_coverage?.recovery_and_pending?.map((item) => ({
                name: item?.name,
                Recovered: item?.total_recovery,
                Pending: item?.pending_amount,
                total_loan_count: item?.total_loan_count,
              }))
            }
            keys={recoveryPendingData?.keys}
            tooltipType={"attempts"}
            colors={recoveryPendingData?.colors}
            keysVisible={false}
            chartName="Portfolio"
            loading={analysis_coverage?.loading}
            format_type="currency"
          />
        </div>
        <div className="action_code_coverage_chart_wrapper coverage-chart-wrapper">
          <div className="heading action-code-heading">
            <h2>Action Code Coverage</h2>
            <div className="chart-items">
              <Tabs
                options={[
                  { label: "Absolute Value", value: "Absolute Value" },
                  { label: "Percentage", value: "Percentage" },
                ]}
                onChange={(val) => {
                  setSelectedTab(val); // ✅ ensure active tab state updates
                  setActionCodeMode(
                    val === "Percentage" ? "_percentage" : "_count"
                  );
                }}
                active={selectedTab}
                classname="active-inactive-tab"
                selectorBreakpoint={370}
                showSelector={true}
              />

              <div
                className="file-download-wrapper"
                style={{ marginLeft: "0" }}
              >
                <ExcelDownloader
                  data={analysis_coverage?.action_code_coverage}
                  fileName="Action Code Coverage"
                />
              </div>
            </div>
          </div>

          <StackedBarChart
            title="Action Code Coverage"
            data={data}
            keys={keys}
            tooltipType="team"
            colors={colors}
            keysVisible={true}
            chartName="Portfolio"
            variant="detailed"
            loading={analysis_coverage?.loading}
          />
        </div>

        <div className="hml_categorization_chart_wrapper coverage-chart-wrapper">
          <div className="heading hml_heading">
            <h2>HML Categorization</h2>
            <div className="chart-items">
              <Tabs
                options={[
                  { label: "All", value: "All" },
                  { label: "Field Agent", value: "Field Agent" },
                  { label: "Tele Caller", value: "Tele Caller" },
                ]}
                active={selectTab} 
                onChange={setSelectTab} 
                classname="active-inactive-tab"
                selectorBreakpoint={400}
                showSelector={true}
              />
              <div className="download-and-filter">
                <Button
                  style={{ height: "35px", fontWeight: 500 }}
                  onClick={() => setOpen(true)}
                >
                  Filter <DownOutlined />
                </Button>

                <div
                  className="file-download-wrapper"
                  style={{ marginLeft: "0" }}
                >
                  <ExcelDownloader
                    data={analysis_coverage?.hml_categorization}
                  />
                </div>
              </div>
            </div>
          </div>
          <StackedBarChart
            title="Action Code Coverage"
            data={analysis_coverage?.hml_categorization?.map((item) => ({
              name: item?.team_leader,
              Low: item?.low_percentage,
              Medium: item?.medium_percentage,
              High: item?.high_percentage,
              team_members: item?.team_members_count,
            }))}
            keys={hmlCategorizationData?.keys}
            tooltipType={"team"}
            colors={hmlCategorizationData?.colors}
            keysVisible={true}
            chartName="Team Leaders"
            variant="compact"
            loading={analysis_coverage?.loading}
          />
        </div>
      </div>
      <ChartFilterModal
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        open={open}
        setOpen={setOpen}
        setSecondaryItems={setSecondaryItems}
        selectedTrustMap={selectedTrustMap}
        setSelectedTrustMap={setSelectedTrustMap}
        setRefresh={setRefresh}
      />
    </>
  );
};
export default CoveragePage;
